import { Component } from 'src/utils';
import template from './subscription.html';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';


@Component({
  controllerAs: 'subscription',
  template
})

export default class Subscription {
  static $inject = [
    '$scope',
    '$ngRedux',
    'spinnerService',
    'orderService',
    'orderActions',
    'authService',
    '$state',
    'toaster',
    'APP',
    '$window',
    '$stateParams'
  ];

  constructor($scope, $ngRedux, $spinner, $order, orderActions, $auth, $state, toaster, $stateParams, 
  $window, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.orderFetched = false;
    this.$order = $order;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$state = $state;
    this.$auth = $auth;
    this.toaster = toaster;
    this.cancelingSubscriptionID = "";
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    this.$state = $state;
    this.APP = APP;
    

/*
    $ngRedux.dispatch(orderActions.setSubscriptions([]));
*/
    $spinner.show('appSpinner');
    $order.getSubscriptions()
      .finally(() => {
        this.orderFetched = true;
        $spinner.hide('appSpinner');
      });

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {

    var subscription = "";
    if (state.order.subscriptions.length > 0){
      subscription = state.order.subscriptions;
    }




    return {
      profile: state.auth.profile,
      recentOrder: subscription
    };
  }


  goToHomePage() {
    let storeName = '';


    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  ReOrder(orderId) {
    this.$order.reOrder(orderId)
    .then(
      success => {
        this.$auth.getUserProfile();
        if (success.data.successCode === '200') {
          this.$state.go('cart');
        }
        else {
          this.toaster.pop('success', 'There is a problem retrieving data. Please add order manually.');
        }
      },
      error => {} // console.log(error)
    )
    .finally(() => {} // console.log('error')
  );
  }

  cancelSubscription(orderId){
    this.cancelingSubscriptionID = "";
    var ctrl = this;
    // console.log('orderId--',orderId);
    this.$order.cancelSubscription(orderId)
        .then(
      success => {
      if (success.data.successCode === '200') {
          this.toaster.pop('success', 'The subscription is successfully cancelled');
      var current =  ctrl.$state.current;
      var params = angular.copy( ctrl.$stateParams);
      ctrl.$state.transitionTo(current, params, { reload: true, inherit: true, notify: true });
        }
        else {
          this.toaster.pop('success', 'There is a problem canacelling subscription. Please try again later');
         }
      },
    () => {
       this.toaster.pop('success', 'There is a problem canacelling subscription. Please try again later');
     }
      ).finally(() => {}
      // console.log('error')
    );
  }
  editSubscription(order){

      this.$auth.resetSubscriptionCart();
      this.$auth.saveSubscriptionLocalState({});
      this.$state.go('subscription-detail',{subscriptionId:order.id,option:'edit'});

  }
  convertDate(cdate){
    var date =  new Date(cdate);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    if (month < 10){
      month = '0' + month.toString();
    }
    if (day < 10){
      day = '0' + day.toString();
    }

     cdate = day + '-' + month + '-' + year;

    return cdate;
  }

}



// WEBPACK FOOTER //
// ./src/app/order/subscription/subscription.js